import { createApp, defineComponent, ref, computed } from 'vue';
import PhoneNumber from '../_00_elements/tools/phoneNumber';
import PhoneInput from './components/PhoneInput.vue';

export default function initVuePhoneInput(idSelector: string) {
    const el = document.getElementById(idSelector) as HTMLDivElement;
    if (!el) {
        throw new Error(`#${ idSelector } selector not found`);
    }

    const phone = el.dataset.phone || '';
    const originalInputName = el.dataset.name || '';

    const TwigPhoneInputComponent = defineComponent({
        components: { PhoneInput },
        setup(_, { expose }) {
            const phoneNumber = ref<PhoneNumber>(new PhoneNumber(phone));
            const phoneNumberString = computed<string>(() => phoneNumber.value?.international ?? '');
            const inputName = ref<string>(`vue_${ originalInputName }`)
            const error = ref<string|null>(null);
            expose({
                error,
            });
            return {
                phoneNumber,
                phoneNumberString,
                originalInputName,
                inputName,
                error,
            };
        },
        template: `
            <PhoneInput
                v-model="phoneNumber"
                :class="{ error: !!error }"
                :inputName="inputName"
            />
            <input type="hidden" :name="originalInputName" :value="phoneNumberString" />
            <label v-if="!!error" class="error in-vue-component">{{ error }}</label>
        `,
    });

    return createApp(TwigPhoneInputComponent).mount(el);
}
